import React from 'react';
import { Title } from '../order/order.style';
import { Box } from '@material-ui/core';
import BlockIcon from '@material-ui/icons/BlockOutlined';
import ReplyIcon from '@material-ui/icons/ReplyOutlined';

import { OrderDetailsItem } from '../item/orderDetailsItem';
import { Tag } from '../status/orderDetailsStatus.style';
import { RefundIconButton, StatusItems } from './orderDetailsBox.style';

export const OrderDetailsBox = ({
  title,
  items,
  width,
  status,
  isRefundEnabled,
  handleRefundClick
}) => {
  return (
    <Box
      width={width ? width : '100%'}
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <Title>{title}</Title>
      <Box
        display="flex"
        style={{
          border: '1px solid #E2E2E2',
          padding: '12px 16px',
          borderRadius: '8px',
          flex: '1'
        }}
      >
        {items.map((item, index, { length }) => {
          return (
            <Box
              key={index}
              display="flex"
              style={{
                flex: '1 0 100%',
                gap: '8px'
              }}
            >
              {item.src && (
                <img
                  src={item.src}
                  alt="Imagem da forma de pagamento"
                  style={{
                    marginRight: '10px',
                    width: '35px',
                    height: '35px',
                    borderRadius: '8px'
                  }}
                />
              )}
              <OrderDetailsItem
                style={{ marginRight: length - 1 === index ? '0px' : '30px' }}
                title={item.title}
                label={item.label}
                hasItalicLabel={item.hasItalicLabel}
                maxWidth={item.maxWidth}
              />
              {(status) && (
                <StatusItems>
                  <Box style={{ height: 27, alignSelf: 'center' }}>
                    <Tag color={status === 'Pago' ? '#119C4A' : '#D8B462'}> {status}</Tag>
                  </Box>
                  {
                    status !== 'Estornado' && (
                      <RefundIconButton
                        aria-label="filter list"
                        disabled={!isRefundEnabled}
                        onClick={handleRefundClick}
                      >
                        {isRefundEnabled ? <ReplyIcon /> : <BlockIcon />}
                        Estornar
                      </RefundIconButton>
                    )
                  }
                </StatusItems>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
